<template>
  <el-dialog
    id="responseModal"
    title="Status change"
    :visible.sync="showLocal"
    :width="dialogWidth"
  >
    Are you sure you want to change coworker's relationship?

    <div
      class="dialogActions"
      :class="['tablet', 'mobile'].includes($mq) ? 'mobileMode' : 'deskMode'"
    >
      <el-button
        type="primary"
        round
        @click="$emit('changeStatus')"
      >
        Submit
      </el-button>
      <el-button
        type="info"
        round
        @click="showLocal = false"
      >
        Cancel
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import dialog from '@/mixins/dialog';

export default {
  name: 'StatusChangeModal',

  mixins: [dialog],

  computed: {
    showLocal: {
      get() {
        return this.show;
      },
      set(newValue) {
        this.$emit('update:show', newValue);
        if (!newValue) {
          this.$emit('update:selectedSurvey', null);
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
  .dialogActions {
    padding: 20px 0 0;
    text-align: right;

    &.mobileMode {
      .el-button {
        width: 100%;
        margin: 5px 0;
      }
    }
  }
</style>
